<template>
  <wb-button-group
    class="emh-ui-button-group"
    :class="{
      '-disabled': disabled,
    }"
  >
    <label
      v-for="option in options"
      :key="option.key"
      class="wb-button wb-button--secondary wb-button--medium"
      :data-test-id="`emh-ui-button-group__option-${option.key}`"
    >
      <input
        type="radio"
        :name="groupName"
        :checked="option.selected"
        :disabled="option.disabled"
        :value="option.value"
        @change="changeOption(option)"
      />
      {{ option.label }}
    </label>
  </wb-button-group>
</template>

<script lang="ts">
export default { name: 'UiButtonGroup' };
</script>

<script lang="ts" setup>
import { PropType } from 'vue';
import { ButtonGroupOption } from './button-group.model';

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array as PropType<ButtonGroupOption[]>,
    default: () => [],
  },
  groupName: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['change-option']);

const changeOption = (option: ButtonGroupOption) => emit('change-option', option);
</script>
<style lang="scss" scoped>
.emh-ui-button-group {
  label {
    width: 100%;
    min-width: 120px;
    min-height: 56px;
  }
  &.-disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}
</style>
